export default __webpack_public_path__ + "img/favicons/favicon-194x194.png";